<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="currentItem == null">
    <h1 class="content-heading-font">Ticket Statuses</h1>

    <div class="row">
      <div class="col-12">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100]"
                 [totalRecords]="list?.FilteredRecords"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
                 sortMode="multiple"
                 [filters]="{Archived: [{ value: 'false', matchMode: 'contains', operator: 'and'}]}">

          <ng-template pTemplate="header">
            <tr>
              <th class="text-end" style="width:120px;"></th>
              <th pSortableColumn="ID" class="text-end d-none d-md-table-cell">
                #
                <p-sortIcon field="ID"></p-sortIcon>
                <p-columnFilter type="numeric" field="ID" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="SupportTicketStatus" class="text-start">
                Status
                <p-sortIcon field="SupportTicketStatus"></p-sortIcon>
                <p-columnFilter type="text" field="SupportTicketStatus" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="GitHub_Status" class="text-start">
                GitHub Status
                <p-sortIcon field="GitHub_Status"></p-sortIcon>
                <p-columnFilter type="text" field="GitHub_Status" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Archived" class="text-start d-none d-lg-table-cell">
                Status
                <p-sortIcon field="Archived"></p-sortIcon>
                <p-columnFilter type="boolean" field="Archived" display="menu" [showMatchModes]="false" [showOperator]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown [options]="[{ name: 'Any', value: '' },{ name: 'Active', value: 'false' },{ name: 'Archived', value: 'true' }]" [ngModel]="value" placeholder="Any" (onChange)="filter($event.value)" optionLabel="name" optionValue="value">
                    </p-dropdown>
                  </ng-template>
                </p-columnFilter>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <th class="text-end">
                <div class="gap-2 d-block">
                  <a class="btn btn-sm btn-primary me-1" (click)="onRowEditInit(item)" title="Edit">
                    <i class="pi pi-pen-to-square"></i>
                  </a>
                  <a class="btn btn-sm btn-warning" (click)="onRowDeleteInit(item)" title="Archive">
                    <i class="pi pi-trash"></i>
                  </a>
                </div>
              </th>
              <th class="text-end d-none d-md-table-cell">{{ item.ID }}</th>
              <td>{{ item.SupportTicketStatus }}</td>
              <td>{{ item.GitHub_Status }}</td>
              <td class="d-none d-lg-table-cell">
                <div [ngClass]="{'text-danger': item.Archived, 'text-success': !item.Archived}">
                  {{ item.Archived ? 'Archived' : 'Active' }}
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="paginatorleft">
            <button class="btn btn-primary" (click)="addItem()" title="Add item">
              <i class="pi pi-plus"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary" (click)="loadTable(null)" title="Refresh">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary" (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6">No items found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <div class="main-page-content-block" *ngIf="currentItem != null">
    <div class="float-end">
      <a class="btn btn-secondary" (click)="cancel()">View list</a>
    </div>

    <h1 class="content-heading-font">
      <span *ngIf="currentItem && currentItem.SupportTicketStatusID">
        Ticket Status #{{ currentItem.SupportTicketStatusID }}
      </span>
      <span *ngIf="!(currentItem && currentItem.SupportTicketStatusID)">
        New Ticket Status
      </span>
    </h1>

    <form #itemForm="ngForm" [formGroup]="itemFormGroup">
      <div class="row">
        <div class="col mb-3">
          <label for="SupportTicketStatus">Ticket Status</label>
          <input class="form-control" name="SupportTicketStatus" formControlName="SupportTicketStatus" autocomplete="off" required="required" />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col mb-3">
          <div for="GitHub_Statuses" class="mb-1 align-items-baseline">
            GitHub Statuses: <button class="ms-2 btn btn-outline-primary   " (click)="addSubItem()" title="Add item" type="button" *ngIf="GitHub_Statuses"><i class="pi pi-plus"></i></button>
          </div>
          <ng-container formArrayName="GitHub_Statuses">
            <ng-container *ngFor="let GitHub_StatusesForm of GitHub_Statuses.controls; let i = index">
              <table class="w-100 mb-1">
                <tr>
                  <td>
                    <div class="row g-0">
                      <div class="col-12">
                        <input class="form-control"  [formControlName]="i" autocomplete="off" required="required" />
                      </div>
                    </div>
                  </td>
                  <td style="width: 50px;vertical-align:bottom; text-align:right">
                    <button class="btn  btn-outline-danger" (click)="deleteSubItem(i)" title="Remove item" type="button"><i class="pi pi-trash"></i></button>
                  </td>
                </tr>
              </table>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div class="row">
        <div class="col mb-3">
          <label for="Archived">Status</label>
          <select class="form-control" name="Archived" formControlName="Archived">
            <option [ngValue]="false">Active</option>
            <option [ngValue]="true">Archived</option>
          </select>
        </div>
      </div>

      <div class="text-end mt-3">
        <button type="button" class="btn btn-secondary me-2" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" [class.button-loading]="loading" [disabled]="itemFormGroup.invalid || loading" (click)="save()">Save</button>
      </div>
    </form>
  </div>
</div>
